(function(){
  var frame = document.getElementById('bison-quote-page-frame');
  if (!frame) return;
  try {
    var incoming = new URLSearchParams(window.location.search);
    var pass = new URLSearchParams();
    ['bollard','qty','postcode','timing','fit','t','utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'].forEach(function(k){
      var v = incoming.get(k);
      if (v) pass.set(k, v);
    });
    pass.set('embed','1');
    pass.set('src_page', window.location.pathname);
    frame.src = 'https://bollard-quote-ff6fe7f6.viktor.space/?' + pass.toString();
    // Fitting-offer links from the order email: hide the supply+fit guide prices below the tool
    // (they contradict the discounted install-only quote). Normal visitors still see them.
    if (incoming.get('fit')) { var g = document.querySelector('.bqf'); if (g) g.style.display = 'none'; }
  } catch(e) {}
  window.addEventListener('message', function(e){
    if (!e.data || e.data.type !== 'bison-quote-height') return;
    var h = parseInt(e.data.height, 10);
    if (h && h > 300) frame.style.height = h + 'px';
  });
})();
